export default {
    emits: ['change', 'update:value'],
    props: {
        data: {
            default: {}
        },
        kee: {
            type: String,
            default: ''
        },
        value: {
            type: Array,
            default: []
        },
        theme: {
            type: String,
            default: 'standard'
        },
        siteId: {
            type: [String, Number]
        },
        inMore: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        needGroup() {
            const { typeLabels } = this.data;
            return typeLabels && Object.keys(typeLabels).length > 0;
        },
        isExact() {
            return !this.data.freeInput;
        }
    },
    data: function() {
        return {
            options: [],
            loading: false
        };
    },
    methods: {
        async onRemoteMethod(val) {
            const { suggestionUrl } = this.data;
            if (!suggestionUrl || !this.siteId) {
                return; 
            }
            this.loading = true;
            try {
                let ret = await this.axiosIns.get(suggestionUrl, {
                    params: { siteId: this.siteId, key: val }
                });
                this.handleData(ret);
                this.loading = false;
            } catch (e) {
                this.loading = false;
                console.error(e);
            }
        },
        handleData(data) {
            if (this.needGroup) {
                const { typeLabels } = this.data;
                const type2Text = {};
                data = data.reduce((acc, cur) => {
                    const type = cur.type;
                    type2Text[type] = cur.typeText;
                    acc[type] = cur.list.map(o => {
                        return {
                            ...o,
                            type,
                            value: `${type}:${o.value}`
                        };
                    });
                    return acc;
                }, {});
                const options = [];
                Object.keys(typeLabels).forEach(type => {
                    const label = typeLabels[type];
                    options.push({
                        label: type2Text[type] || label,
                        data: data[type] || []
                    });
                });
                this.options = options.filter(item => item.data.length > 0);
            } else {
                this.options = data
                    .map(item => {
                        return {
                            label: item.typeText,
                            data: item.list.map(o => {
                                return {
                                    ...o,
                                    type: item.type,
                                    value: `${item.type}:${o.value}`
                                };
                            })
                        };
                    })
                    .filter(item => item.data.length > 0);
            }
        }
    }
};
